import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { PageEvent } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { MatRadioChange } from '@angular/material/radio';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { DatePipe } from '@angular/common'
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SelectFormIconComponent } from 'src/app/middleware/common/selectFormIcon/selectFormIcon.component';
import { FormsService } from '../../eSignature/services/forms.service';
import { map, startWith } from 'rxjs/operators';
import { AddUpdateProcessStageComponent } from 'src/app/middleware/common/addupdateProcessStage/addupdateProcessStage.component';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-manage-tasktemplates',
  templateUrl: './manage-tasktemplates.component.html',
  styleUrls: ['./manage-tasktemplates.component.scss']
})
export class ManageTaskTemplatesComponent implements OnInit {

  currentUser: any;
  organizationId: string;
  databaseId: string;
  responseHolder: any;
  templateList: any;
  value = '';
  filterText: any;
  paginatorTotalLength: any;
  pageIndex: any;
  pageSize: any;
  currentData: PageEvent;
  OfficeIDList: any = [];
  myOfficeID: any;
  ShowNoRecordFound: boolean = false;
  taskTemplateList: any = [] = [];

  updateformDialog: FormGroup;
  taskTemplateID: number = 0;
  spinner: boolean = false;
  taskListFolder: any = [] = [];
  taskListFolderSharedWithMe: any = [] = [];
  taskListFolderID: number = 0;
  taskListFolderIDSharedWithMe: number = 0;
  ButtonForFolder: boolean = false;
  SendEmailList: any[] = [];
  SendMobileList: any[] = [];
  AddTaskListEmailResult: any = [];
  addButtonShow: boolean = false;
  emailid: string = "";
  mobileNo: string = "";
  CoreShowName: string = '';
  ContactShowName: string = '';
  CompanyShowName: string = '';
  menuModulesList: any = ([] = []);
  formIcon: any;
  attachedToContactList: any[];
  ContactfolderID: any;
  contactsSelectedList: any=[];
  selectedCoreEmailID: string='';
  relationList: any=[];


  constructor(private formBuilder: FormBuilder, private formService: FormsService, private loaderService: LoaderService,
    private toastr: ToastrService, private statusConst: StatusConstant,
    private reusableClass: ReusableClasses, private dialog: MatDialog,
    private settingsService: SettingService, private encryptionAlgo: EncryptionService,
    private httpClient: HttpClient, private constant: Constants,private customValidator: CustomvalidationService,
    public datepipe: DatePipe) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });

    this.stateCtrl.setValue(this.stateCtrlValue);
        this.filteredStates = this.stateCtrl.valueChanges.pipe(
          startWith(''),
          map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );
  }

 private _filterStates(value: string): State[] {    
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }


  ngOnInit(): void {
    this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter((x) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
    }

    SelectedContact = this.menuModulesList.filter((x) => x.mainModuleName == 'Contact');
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;
    }

    SelectedCompany = this.menuModulesList.filter((x) => x.mainModuleName == 'Company');
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;    
    }
    this.getTaskTemplateList();
  }

  linkCopied() {
    this.toastr.success('Link copied.', '', {
      timeOut: 3000,
    });
  }

    selectIcon(form){
          const dialogRef = this.dialog.open(SelectFormIconComponent, {    
           
          });
          dialogRef.afterClosed().subscribe(result => {
            if(result!=null && result!=undefined){
              this.formIcon = result;
              this.addDashboardQuicklink(form, result);
             // this.iconName = result.name;  
            }
          }); 
        }
  
        addDashboardQuicklink(form, result){   
          var ReqModel = {
           id: form.taskTemplateID,
           name: form.taskTemplateName,
           taskListFolderID:form.taskListFolderID,
           favoriteType:2, //Tasklist
           url:"",
           icon:result.icon,
           color: result.color,
           userID: this.currentUser.UID,
           organizationID: Number(this.organizationId),
           databaseID: Number(this.databaseId),
           officeID:this.myOfficeID,
         };
          this.loaderService.show()
          this.formService.AddDashboardFavoriteItem(ReqModel).subscribe((response) => {
           if (response != undefined) {
             this.responseHolder = response;
             this.loaderService.hide();
              if (this.responseHolder.status == this.statusConst.statusSuccess) {  
                this.toastr.success('Dashboard Quick Link Added successfully.', '', {
                  timeOut: 3000,
                });
             } else {
              this.toastr.error('Error occurred.', '', {
                timeOut: 3000,
              });
               this.loaderService.hide();
             }
           } else {
             this.loaderService.hide();
           }
         });
         
       }


  AddEmail(e: any) {
    if(this.name==""){
      this.toastr.warning("Please add name.");
      return;
    }
    if(this.sendForSign.length>0){
      var check=[];
      check = this.sendForSign.filter(x=> x.email.toLowerCase()==e.target.value.toLowerCase());
      if(check.length>0){      
       var createdDateTime = new Date((check[0].lastSentDate) + 'Z');

       let lastSenddate = this.datepipe.transform(createdDateTime, 'dd-MM-yyyy');
       let todayDate = this.datepipe.transform( new Date(),'dd-MM-yyyy');
 
       if(lastSenddate==todayDate){
         this.toastr.warning("Tasklist allready sent given email-id with same date.");
         return;
       }    
      }
     }

    if (this.SendEmailList.length >= 5) {
      this.toastr.warning("only 5 email are allowed.");
    } else {
      const emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let result = emailregex.test(e.target.value);
      if (result) {
        if (!this.SendEmailList.includes(e.target.value.toLowerCase()))
          var obj={
            emailid:e.target.value.toLowerCase(),
            name:this.name
          }
          this.SendEmailList.push(obj);
       // this.SendEmailList.push(e.target.value.toLowerCase());
        e.target.value = '';
        this.emailid = "";
        this.addButtonShow = false;
        this.name="";
      } else {
        this.toastr.warning("Please add a valid email.");
        this.addButtonShow = false;
      }
    }
  }

  addEmails() {

    if(this.name==""){
      this.toastr.warning("Please add name.");
      return;
    }

    if(this.sendForSign.length>0){
     var check=[];
     check = this.sendForSign.filter(x=> x.email.toLowerCase()==this.emailid.toLowerCase());
     if(check.length>0){

       var createdDateTime = new Date((check[0].lastSentDate) + 'Z');

       let lastSenddate = this.datepipe.transform(createdDateTime, 'dd-MM-yyyy');
       let todayDate = this.datepipe.transform( new Date(),'dd-MM-yyyy');

      if(lastSenddate==todayDate){
        this.toastr.warning("Tasklist allready sent given email-id with same date.");
        return;
      }    
     }
    }


    if (this.SendEmailList.length >= 5) {
      this.toastr.warning("only 5 email are allowed.");
    } else {
      if (!this.SendEmailList.includes(this.emailid.toLowerCase())) {
        var obj={
          emailid:this.emailid.toLowerCase(),
          name:this.name
        }
        this.SendEmailList.push(obj);
       // this.SendEmailList.push(this.emailid.toLowerCase());        
        this.emailid = "";
        this.name="";
        this.addButtonShow = false;
      } else {
        this.addButtonShow = false;
        this.toastr.warning("email allready exist.");
      }
    }

  }

  checkEmail(val) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var check = re.test(String(val).toLowerCase());
    if (check == true) {
      this.addButtonShow = true;
    } else {
      this.addButtonShow = false;
    }
  }

  removeEmail(email: any) {
    let removeIndex = this.SendEmailList.findIndex((itm) => itm.emailid === email);
    if (removeIndex !== -1) this.SendEmailList.splice(removeIndex, 1);    
    //this.SendEmailList = this.SendEmailList.filter(m => m.emailid!== email);
  }

  removeCore(email: any) {
    let removeIndex = this.selectCoreList.findIndex((itm) => itm.emailid === email);
    if (removeIndex !== -1) this.selectCoreList.splice(removeIndex, 1);   
  }

  showDetail: boolean = false;
  mainModuleNameForDetails:string="";
  transactionID: number = 0;

  editCore(data:any){
    this.mainModuleNameForDetails="Core";
    this.transactionID=data.coreID;
    this.showDetail = !this.showDetail;
    this.dialog.closeAll();
  }   

  getCloseDetails(message){
    this.showDetail = false;
  }

  getTaskTemplateList() {
    this.loaderService.show();
    var ReqModel = {
      folderID:0,
      searchKey:"",
      type: Number(this.categoryTypeForTaskTemplates),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.settingsService.getTaskTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
          this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.taskTemplateList = this.responseHolder.data;
          if (this.taskTemplateList.length > 0) {
            this.taskTemplateList.forEach(e => {
              // dcrypt tooken
              let params = decodeURIComponent(e.token);
              const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
              let decryptedToken = JSON.parse(tokenm);

              decryptedToken.templateCreatedUserID = decryptedToken.UserID;
              decryptedToken.templateCreatedOrganizationID = decryptedToken.OrganizationID;
              decryptedToken.templateCreatedOfficeID = decryptedToken.OfficeID;

              decryptedToken.UserID = this.currentUser.UID;
              decryptedToken.OfficeID = this.myOfficeID;
              decryptedToken.OrganizationID = this.organizationId;
              //
              // encrypt token
              const jsonString = JSON.stringify(decryptedToken)
              const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
              const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);
              e.token = encryptedTokenWithEncoding;
              //
              e.token = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + e.token;
            });
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskTemplateList = [];
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound = true;
        this.taskTemplateList = [];
        this.loaderService.hide();
      }
    });
  }


  UpdateTaskDialog(templateRef: TemplateRef<any>, task: any) {
    let group = {};
    this.updateformDialog = new FormGroup(group);
    this.taskTemplateID = task.taskTemplateID;
    this.updateformDialog.addControl('taskTemplateName', this.formBuilder.control(''));
    this.updateformDialog.controls['taskTemplateName'].setValue(task.taskTemplateName);
    this.dialog.open(templateRef);
    this.updateformDialog.markAsPristine();
  }


  UpdateTaskTemplate(data) {
    let ReqModel = {
      taskTemplateID: this.taskTemplateID,
      taskTemplateName: data.taskTemplateName,
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
    }
    this.loaderService.show();
    this.spinner = true;
    this.updateformDialog.markAsPristine();
    this.settingsService.renameTaskTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.spinner = false;
          this.dialog.closeAll();
          this.toastr.success('Task template update successfully.', '', {
            timeOut: 3000,
          });
          this.getTaskTemplateList();
          this.loaderService.hide();
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
        } else {
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
          this.spinner = false;
          this.loaderService.hide();
          this.toastr.error('Task template update failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.showOptionForDelete = false;
        this.selectedRecordDelete = [];
        this.spinner = false;
        this.loaderService.hide();
        this.toastr.error('Task template update failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }


  UpdateTemplateToggle(task: any, event: any) {
    this.loaderService.show();
    var ReqModel = {
      taskTemplateID: task.taskTemplateID,
      activate: event.checked,
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
    }
    this.settingsService.activateTaskTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Status updated successfully.', '', {
            timeOut: 3000,
          });
          this.getTaskTemplateList();
          this.loaderService.hide();
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
        } else {
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
          this.loaderService.hide();
          this.toastr.error('Status update failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.showOptionForDelete = false;
        this.selectedRecordDelete = [];
        this.loaderService.hide();
        this.toastr.error('Status update failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }


  closeUpdate() {
    this.updateformDialog.reset();
    this.dialog.closeAll();
  }



  //================== Associate TaskList Folder to Task Template =========///

  OpenFolder(templateRef: TemplateRef<any>, taskTemplate: any) {
    this.taskTemplateID = taskTemplate.taskTemplateID;
    if (taskTemplate.taskListFolderID > 0) {
      this.taskListFolderID = taskTemplate.taskListFolderID;
      this.taskListFolderIDSharedWithMe  = taskTemplate.taskListFolderID;
    } else {
      this.taskListFolderID = 0;
      this.taskListFolderIDSharedWithMe=0;      
    }  
    this.ButtonForFolder = false;
    this.ButtonForUploadImage = false;
    this.taskListFolder = [];
    this.taskListFolderSharedWithMe=[];
    this.getTaskListFolders();
    this.GetTasklistFolderSharedWithMe();
    this.dialog.open(templateRef);
  }

  OpenFolderSendEmail(templateRef: TemplateRef<any>, taskTemplate: any) {
    this.taskTemplateAfterAddingCore=taskTemplate;
   // this.checkedByDefaultEmail=true;
    this.checkedByDefaultCore=true;
    this.TaskListName=taskTemplate.taskTemplateName;
    this.name="";
    this.emailid = "";
    this.addButtonShow = false;
    this.SendEmailList = [];
    
    this.AttachChecked=false;
    this.AssigneeChecked=true;
    this.NotifyChecked=false;
    this.SendEmailLater=false;

    this.showSearchCore=false;
    this.selectCoreList=[];

    this.taskTemplateID = taskTemplate.taskTemplateID;
    this.GetRelationByTaskTemplateID(taskTemplate.taskTemplateID);
    if (taskTemplate.taskListFolderID > 0) {
      this.taskListFolderID = taskTemplate.taskListFolderID;
    } else {
      this.taskListFolderID = 0;
    }

    this.showTemplateDetailCheckingDuplicateEmail(taskTemplate.taskTemplateID);
    this.ButtonForFolder = false;
    this.ButtonForUploadImage = false;

    this.showEmail=false;
    this.showMobile=false;
    this.SendEmailList=[];
    this.SendMobileList=[];
    this.emailid="";
    this.mobileNo="";

    this.sendButton=false;

    this.dialog.open(templateRef);
  }

  showTemplateDetailCheckingDuplicateEmail(templateID) {
    this.loaderService.show();    
    this.currentTemplateId = templateID;
    let ReqModel = {
      "taskTemplateID": templateID,
      "userID": this.currentUser.UID,
      "organizationID": Number(this.organizationId),
      "officeID": this.myOfficeID,
      "officeIDList": this.OfficeIDList,
      "databaseID": Number(this.databaseId),
    }
    this.settingsService.getTaskTemplateEmailLog(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.sendForSign = response.data;
        }
      }
    })

  }

  getTaskListFolders() {
    this.loaderService.show();
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.settingsService.getTaskListFolders(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskListFolder = response.data.taskListFolders;
        }
        else {
          this.taskListFolder = [];
          this.loaderService.hide();
        }
      }
      else {
        this.taskListFolder = [];
        this.loaderService.hide();
      }
    });
  }


  GetTasklistFolderSharedWithMe(){    
    var ReqModel ={
     taskListFolderID: 0,
     taskListFolderName: "",
     userID : this.currentUser.UID,
     organizationID : Number(this.organizationId),  
     databaseID : Number(this.databaseId),    
     permissionType: 0,
     officeID:this.myOfficeID  
    }
    this.settingsService.getTasklistFolderSharedWithMe(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.responseHolder = response;
       this.loaderService.hide();
       if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
         this.taskListFolderSharedWithMe = response.data;          
       }
       else {        
         this.taskListFolderSharedWithMe=[];             
         this.loaderService.hide();
       }
     }
     else {       
       this.taskListFolderSharedWithMe=[];
       this.loaderService.hide();
     }
   });    
  }

  selectTaskListFolder(tasklist) {
    this.taskListFolderIDSharedWithMe=0;
    this.taskListFolderID = tasklist.taskListFolderID;
    this.ButtonForFolder = true;
  }

  selectTaskListFolderSharedWithMe(tasklist) {
    this.taskListFolderID =0;
    //this.taskListFolderID = tasklist.id;
    this.taskListFolderIDSharedWithMe  = tasklist.id;
    this.ButtonForFolder = true;
  }

  AddUpdateTaskListFoldertoTaskTemplate() {
    if(this.taskListFolderIDSharedWithMe!=0){
      this.taskListFolderID = this.taskListFolderIDSharedWithMe;
    }
    var ReqModel = {
      taskListFolderID: this.taskListFolderID,
      tasktemplateID: this.taskTemplateID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.ButtonForFolder = false;
    this.spinner = true;
    this.settingsService.associateTaskListFoldertoTaskTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Task List added in task template successfully.', '', {
            timeOut: 3000,
          });
          this.getTaskTemplateList();
          this.closeFolder();
          this.loaderService.hide();
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
        } else {
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
          this.loaderService.hide();
        }
      } else {
        this.showOptionForDelete = false;
        this.selectedRecordDelete = [];
        this.loaderService.hide();
      }
    });
  }

  name:string="";

  SendEmailForTaskListURL(SendEmailLater:boolean) {       
     if(this.selectCoreList.length>0){
        var coreList=[];
        for (let i = 0; i < this.selectCoreList.length; i++) {
          if (this.selectCoreList[i].isNotASigner == false) {
            this.selectCoreList[i].contactAttachWithCores = [];
          }

          if (this.selectCoreList[i].isNotASigner == true) {
            if (this.selectCoreList[i].contactAttachWithCores.length == 0) {
              this.toastr.warning('Please add ' + this.ContactShowName + '', '', {
                timeOut: 4000,
              });
              return;
            }
            if (this.selectCoreList[i].contactAttachWithCores.length > 0) {
              if (this.relationList.length > 0) {
                var checkRelation: number = 0;
                checkRelation = this.selectCoreList[i].contactAttachWithCores[0].TransctionalRoleID;
                if (checkRelation == 0) {
                  this.toastr.warning('Please Select Relation', '', {
                    timeOut: 4000,
                  });
                  return;
                }
              }
            }
          }

          var objcore={
            cType:1,
            cid:  this.selectCoreList[i].coreID,
            name:this.selectCoreList[i].name,
            emailMobile:this.selectCoreList[i].emailid,
            messageType:0, //0-Core ,1-Email , 2-Mobile,
            contactAttachWithCores:this.selectCoreList[i].contactAttachWithCores,
            isNotASigner:this.selectCoreList[i].isNotASigner!=undefined?this.selectCoreList[i].isNotASigner:false

          }
          coreList.push(objcore);
        }       
      }
      var ReqModel1 = {
        taskListID: 0,
        taskListName: this.TaskListName,
        position: 0,
        folderID: this.taskListFolderID,
        taskTemplateID: this.taskTemplateID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: Number(this.myOfficeID),
        emailMessageTos:coreList,
        isChildDueDate: false,
        keepAssignee: this.AssigneeChecked,
        sendEmailLater: SendEmailLater//this.SendEmailLater
      }
      this.loaderService.show();
      this.ButtonForFolder = false;
      this.spinner = true;
      this.settingsService.SendEmailForTaskListURL(ReqModel1).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.spinner = false;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success('Tasklist url is successfully added .', '', {
              timeOut: 3000,
            });
            this.name="";
            this.mobileNo = "";
            this.addButtonShow = false;
            this.AddTaskListEmailResult = this.responseHolder.data;
            this.AddTaskListEmailResult.forEach(el => {
              el.taskListURL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + el.taskListURL;
            });
            this.loaderService.hide();
            this.SendMobileList = [];
            this.selectCoreList=[];
            this.closeSendTaskListURL();
            this.RecallSendEmailForTaskListURL(ReqModel1, response.data.map(m => m.taskListID));
          }else{
           this.selectCoreList = [];
           this.loaderService.hide();
           this.toastr.error(this.responseHolder.message, '', {
            timeOut: 3000,
           });
          }
        } else {
          this.name="";
          this.mobileNo = "";
          this.addButtonShow = false;
          this.SendMobileList = [];
          this.selectCoreList=[];
          this.loaderService.hide();
        }
      });    
  }

  SendEmailForTaskListURL1() {
    // if(this.showEmail==true){
    //   if(this.SendEmailList.length>0){
    //     var emailList=[];
    //     for (let i = 0; i < this.SendEmailList.length; i++) {
    //       var obj={
    //         name:this.SendEmailList[i].name,
    //         emailMobile:this.SendEmailList[i].emailid,
    //         messageType:1 // 1-Email , 2-Mobile
    //       }
    //       emailList.push(obj);
    //     }       
    //   }      
     
    //   var ReqModel = {
    //     taskListID: 0,
    //     taskListName: this.TaskListName,
    //     position: 0,
    //     folderID: this.taskListFolderID,
    //     taskTemplateID: this.taskTemplateID,
    //     userID: this.currentUser.UID,
    //     organizationID: Number(this.organizationId),
    //     officeID: Number(this.myOfficeID),
    //     emailMessageTos:emailList,
    //     //SendEmailList: this.SendEmailList,
    //     IsChildDueDate: false,
    //     keepAttached: false,//this.AttachChecked,
    //     keepAssignee: this.AssigneeChecked,
    //     keepNotify: this.NotifyChecked,
    //   }
    //  // return;
    //   this.loaderService.show();
    //   this.ButtonForFolder = false;
    //   this.spinner = true;
    //   this.settingsService.SendEmailForTaskListURL(ReqModel).subscribe(response => {
    //     if (response != undefined) {
    //       this.responseHolder = response;
    //       this.spinner = false;
    //       if (this.responseHolder.status == this.statusConst.statusSuccess) {
    //         this.toastr.success('Task List added in task template successfully.', '', {
    //           timeOut: 3000,
    //         });
    //         this.name="";
    //         this.emailid = "";
    //         this.addButtonShow = false;
    //         this.AddTaskListEmailResult = this.responseHolder.data;
    //         this.AddTaskListEmailResult.forEach(el => {
    //           el.taskListURL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + el.taskListURL;
    //         });
    //         //this.SendExternalURLEmail();
    //         this.loaderService.hide();
    //         this.SendEmailList = [];
    //         this.closeSendTaskListURL();
    //         this.RecallSendEmailForTaskListURL(ReqModel, response.data.map(m => m.taskListID));
    //       }
    //     } else {
    //       this.name="";
    //       this.emailid = "";
    //       this.addButtonShow = false;
    //       this.SendEmailList = [];
    //       this.loaderService.hide();
    //     }
    //   });
    // }
    
    // if(this.showMobile==true){
    //   if(this.SendMobileList.length>0){
    //     var mobileList=[];
    //     for (let i = 0; i < this.SendMobileList.length; i++) {
    //       var obj={
    //         name:this.SendMobileList[i].name,
    //         emailMobile:this.SendMobileList[i].mobile,
    //         messageType:2 // 1-Email , 2-Mobile
    //       }
    //       mobileList.push(obj);
    //     }       
    //   }
    //   var ReqModel1 = {
    //     taskListID: 0,
    //     taskListName: this.TaskListName,
    //     position: 0,
    //     folderID: this.taskListFolderID,
    //     taskTemplateID: this.taskTemplateID,
    //     userID: this.currentUser.UID,
    //     organizationID: Number(this.organizationId),
    //     officeID: Number(this.myOfficeID),
    //     emailMessageTos:mobileList,
    //    // SendEmailList: this.SendMobileList,
    //     isChildDueDate: false
    //   }
    //   this.loaderService.show();
    //   this.ButtonForFolder = false;
    //   this.spinner = true;
    //   this.settingsService.SendEmailForTaskListURL(ReqModel1).subscribe(response => {
    //     if (response != undefined) {
    //       this.responseHolder = response;
    //       this.spinner = false;
    //       if (this.responseHolder.status == this.statusConst.statusSuccess) {
    //         this.toastr.success('Tasklist url is successfully sent to mobile.', '', {
    //           timeOut: 3000,
    //         });
    //         this.name="";
    //         this.mobileNo = "";
    //         this.addButtonShow = false;
    //         this.AddTaskListEmailResult = this.responseHolder.data;
    //         this.AddTaskListEmailResult.forEach(el => {
    //           el.taskListURL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + el.taskListURL;
    //         });
    //         //this.SendExternalURLEmail();
    //         this.loaderService.hide();
    //         this.SendMobileList = [];
    //         this.closeSendTaskListURL();
    //         this.RecallSendEmailForTaskListURL(ReqModel1, response.data.map(m => m.taskListID));
    //       }else{
    //         this.loaderService.hide();
    //       }
    //     } else {
    //       this.name="";
    //       this.mobileNo = "";
    //       this.addButtonShow = false;
    //       this.SendMobileList = [];
    //       this.loaderService.hide();
    //     }
    //   });
    // }

    //if(this.showSearchCore==true){
      if(this.selectCoreList.length>0){
        var coreList=[];
        for (let i = 0; i < this.selectCoreList.length; i++) {
          var objcore={
            cType:1,
            cid:  this.selectCoreList[i].coreID,
            name:this.selectCoreList[i].name,
            emailMobile:this.selectCoreList[i].emailid,
            messageType:0, //0-Core ,1-Email , 2-Mobile,
            contactAttachWithCores:this.selectCoreList[i].contactAttachWithCores,
            isNotASigner:this.selectCoreList[i].isNotASigner!=undefined?this.selectCoreList[i].isNotASigner:false

          }
          coreList.push(objcore);
        }       
      }
      var ReqModel1 = {
        taskListID: 0,
        taskListName: this.TaskListName,
        position: 0,
        folderID: this.taskListFolderID,
        taskTemplateID: this.taskTemplateID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: Number(this.myOfficeID),
        emailMessageTos:coreList,
        isChildDueDate: false,
        keepAssignee: this.AssigneeChecked,
        sendEmailLater: this.SendEmailLater
      }
      this.loaderService.show();
      this.ButtonForFolder = false;
      this.spinner = true;
      this.settingsService.SendEmailForTaskListURL(ReqModel1).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.spinner = false;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success('Tasklist url is successfully added .', '', {
              timeOut: 3000,
            });
            this.name="";
            this.mobileNo = "";
            this.addButtonShow = false;
            this.AddTaskListEmailResult = this.responseHolder.data;
            this.AddTaskListEmailResult.forEach(el => {
              el.taskListURL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + el.taskListURL;
            });
            this.loaderService.hide();
            this.SendMobileList = [];
            this.selectCoreList=[];
            this.closeSendTaskListURL();
            this.RecallSendEmailForTaskListURL(ReqModel1, response.data.map(m => m.taskListID));
          }
        } else {
          this.name="";
          this.mobileNo = "";
          this.addButtonShow = false;
          this.SendMobileList = [];
          this.selectCoreList=[];
          this.loaderService.hide();
        }
      });
   // }
    
  }

  RecallSendEmailForTaskListURL(ReqModel, taskListIDs) {
    ReqModel.IsChildDueDate = true;
    ReqModel.ChildTaskListIDs = taskListIDs;
    this.settingsService.SendEmailForTaskListURL(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Child Task List added in task template successfully.', '', {
            timeOut: 3000,
          });         
        }
      } else {
        this.name="";
        this.emailid = "";
        this.addButtonShow = false;
        this.SendEmailList = [];
        this.loaderService.hide();
      }
    });
  }

  SendExternalURLEmail() {
    var ReqModel = {
      AddTaskListEmailResult: this.AddTaskListEmailResult,
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
    }
    this.settingsService.SendExternalURLEmail(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess && response.data != null) {
          if (response.data == true) {
            this.toastr.success("External tasklist url is successfully sent to email.")
          }
        }
      }
    });
  }

  closeFolder() {
    this.spinner = false;
    this.taskListFolderID = 0;
    this.dialog.closeAll();
  }

  closeSendTaskListURL() {
    this.name="";
    this.spinner = false;
    this.SendEmailList = [];
    this.SendMobileList = [];
    this.selectCoreList=[];
    this.dialog.closeAll();
  }

  //================== Upload Image =========///

  imageSrc: string;
  FileName: any;
  FileExtention: any;
  Base64String: any;
  ImageUploadURL: string = "";
  ButtonForUploadImage: boolean = false;
  headerText: string = "";

  onSelectFile(fileInput: any) {
    this.handleInputChange(fileInput.target.files[0]);
    var filename = fileInput.target.files[0].name;
    var test = filename.split('.');
    this.FileName = test[0];
    this.FileExtention = '.' + test[1];
  }

  handleInputChange(files) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    this.FileName = reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    var ReqModel = {
      UserID: this.currentUser.UID,
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      Base64String: this.imageSrc,
      FileName: this.FileName,
      FileExtention: this.FileExtention
    }
    this.settingsService.getImageUlpoadURL(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ImageUploadURL = response.data;
          if (this.headerText != "") {
            this.ButtonForUploadImage = true;
          }
        }
      }
    });
  }

  onSearchChange(searchValue: string) {
    if (searchValue != "") {
      this.headerText = searchValue.trim();
      this.ButtonForUploadImage = true;
    } else {
      this.headerText = "";
      this.ButtonForUploadImage = false;
    }
  }

  editBanner(templateRef: TemplateRef<any>, taskTemplate: any) {
    if (taskTemplate.headerText != null) {
      this.headerText = taskTemplate.headerText;
    } else {
      this.headerText = "";
    }
    if (taskTemplate.headerImageUrl != null) {
      this.ImageUploadURL = taskTemplate.headerImageUrl;
    } else {
      this.ImageUploadURL = "";
    }
    this.taskTemplateID = taskTemplate.taskTemplateID;
    this.ButtonForFolder = false;
    this.ButtonForUploadImage = false;
    this.taskListFolder = [];
    this.dialog.open(templateRef, {
      panelClass: 'upload-banner',
    });
  }

  AddUpdateHeadertoTaskTemplate() {
    var ReqModel = {
      headerImageUrl: this.ImageUploadURL,
      headerText: this.headerText,
      tasktemplateID: this.taskTemplateID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.ButtonForUploadImage = false;
    this.spinner = true;
    this.settingsService.addHeadertoTaskTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Header added in task template successfully.', '', {
            timeOut: 3000,
          });
          this.getTaskTemplateList();
          this.closeFolder();
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  //========== For Delete Record ==============//
  selectedRecordDelete: any = [] = [];
  showOptionForDelete: boolean = false;

  selectRecordForDelete(event, temp) {
    if (event.checked) {
      let ReqModel = {
        selectedRecord: temp.taskTemplateID
      };
      this.selectedRecordDelete.push(ReqModel);
    } else {
      let removeIndex = this.selectedRecordDelete.findIndex((itm) => itm.selectedRecord === temp.taskTemplateID);
      if (removeIndex !== -1) this.selectedRecordDelete.splice(removeIndex, 1);
    }
    if (this.selectedRecordDelete.length > 0) {
      this.showOptionForDelete = true;
    }
    else {
      this.showOptionForDelete = false;
      this.selectedRecordDelete = [];
    }

  }

    SelectforSetDefault(event, temp) {
          var req = {
            templateID: temp.taskTemplateID,
            isDefualt: event.checked,
            userID: this.currentUser.UID,
            officeID: Number(this.myOfficeID),
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId)
          }
          this.loaderService.show();
          this.settingsService.SetDefaultTaskTemplate(req).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.loaderService.hide();
                this.toastr.success('Request successfully updated.', '', {
                  timeOut: 3000,
                });
                this.getTaskTemplateList();
              } else {
                this.loaderService.hide();
                this.toastr.error('Request failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Request failed.', '', {
                timeOut: 3000,
              });
            }
          });
    }


  // getTaskTemplateEmailLog(reqModel): Observable<any> {
  //   const apiURL = this.baseUrlTask + this.apiAddress.getTaskTemplateEmailLog;  
  //   return this._http.post(apiURL,reqModel).pipe();
  // }

  deleteMultipleTaskTemplates() {
    const message = `Are you sure you want to delete selected templates?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var selectedtasklist = [];
          if (this.selectedRecordDelete.length > 0) {
            for (var i = 0, len = this.selectedRecordDelete.length; i < len; ++i) {
              const taskid = this.selectedRecordDelete[i].selectedRecord;
              selectedtasklist.push(taskid);
            }
          }
          var reqModel = {
            tasktemplateIDs: selectedtasklist,
            userID: this.currentUser.UID,
            officeID: Number(this.myOfficeID),
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: Number(this.databaseId)
          }
          this.loaderService.show();
          this.settingsService.removeTaskTemplates(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.showOptionForDelete = false;
                this.selectedRecordDelete = [];
                this.loaderService.hide();
                this.toastr.success('Task templates deleted successfully.', '', {
                  timeOut: 3000,
                });
                this.getTaskTemplateList();
              } else {
                this.showOptionForDelete = false;
                this.selectedRecordDelete = [];
                this.loaderService.hide();
                this.toastr.error('Task deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.showOptionForDelete = false;
              this.selectedRecordDelete = [];
              this.loaderService.hide();
              this.toastr.error('Task deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  showTaskTempalteDetail = false;
  sendForSign: any;
  currentTemplateId :any;

  closeTemplateDetail() {
    this.sendForSign = []
    this.showTaskTempalteDetail = false;
  }

  showTemplateDetail(templateID) {
    this.loaderService.show();
    this.showTaskTempalteDetail = true;
    this.currentTemplateId = templateID;
    let ReqModel = {
      "taskTemplateID": templateID,
      "userID": this.currentUser.UID,
      "organizationID": Number(this.organizationId),
      "officeID": this.myOfficeID,
      "officeIDList": this.OfficeIDList,
      "databaseID": Number(this.databaseId),
    }
    this.settingsService.getTaskTemplateEmailLog(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.sendForSign = response.data;
        }
      }
    })

  }


  resendTaskTemplate(taskTemplateSentToID) {
    this.loaderService.show();
    let ReqModel = {
      "taskTemplateSentToID": taskTemplateSentToID,
      "userID": this.currentUser.UID,
      "organizationID": Number(this.organizationId),
      "officeID": this.myOfficeID,
      "officeIDList": this.OfficeIDList,
      "databaseID": Number(this.databaseId)
    }
    this.settingsService.resendTemplateUrltoEmail(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Resend Template', '', {
            timeOut: 3000,
          });
          this.showTemplateDetail(this.currentTemplateId);
        }
      }
    })

  }

  // Get Errors for phoneNumber field
  getPhoneErrorMessage() {
    return this.customValidator.getPhoneErrorMessage(this.mobileNo);
  }
  //=========================//

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  checkMobileNo(val) {
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    var check = phoneNumberregex.test(String(val).toLowerCase());
    if (check == true) {
      this.addButtonShow = true;
    } else {
      this.addButtonShow = false;
    }
  }

  AddMobileNo(e: any) {
    if(this.name==""){
      this.toastr.warning("Please add name.");
      return;
    }
    if (this.SendMobileList.length >= 5) {
      this.toastr.warning("only 5 mobile no. are allowed.");
    } else {
        var check=[];
        check= this.SendMobileList.filter(m => m === e.target.value);
        if(check.length>0){
          this.toastr.warning("Mobile no. allready exist.");
        }else{
          var obj={
            mobile:e.target.value.toLowerCase(),
            name:this.name
          }
          this.SendMobileList.push(obj);
         //this.SendMobileList.push(e.target.value.toLowerCase());
         e.target.value = '';
         this.mobileNo = "";
         this.name="";
        }         
    }
  }

  addMobilesNo() {
    if (this.SendMobileList.length >= 5) {
      this.toastr.warning("only 5 Mobile no. are allowed.");
    } else {
      if (!this.SendMobileList.includes(this.mobileNo.trim().toLowerCase())) {
        var obj={
          mobile:this.mobileNo.trim().toLowerCase(),
          name:this.name
        }
        this.SendMobileList.push(obj);
       // this.SendMobileList.push(this.mobileNo.trim().toLowerCase());
        this.mobileNo = "";
        this.name="";
        this.addButtonShow = false;
      } else {
        this.addButtonShow = false;
        this.toastr.warning("Mobile no. allready exist.");
      }
    }

  }

  removeMobile(mobile: any) {
    let removeIndex = this.SendMobileList.findIndex((m) => m.mobile === mobile);
    if (removeIndex !== -1) this.SendMobileList.splice(removeIndex, 1);    
    //this.SendMobileList = this.SendMobileList.filter(m => m.mobile !== mobile);
  }

  showAuthenticationType=true;
  showEmail:boolean=true;
  showMobile:boolean=false;
  sendButton:boolean=true;

  getTokenEmail(value: MatRadioChange) {
    this.showEmail=true;
    this.showMobile=false;
    this.SendEmailList=[];
    this.SendMobileList=[];
    this.emailid="";
    this.mobileNo="";   

    this.showSearchCore=false;  
    this.selectCoreList=[];
  }

  getTokenMobile(value: MatRadioChange) {
    this.showEmail=false;
    this.showMobile=true;
    this.SendEmailList=[];
    this.SendMobileList=[];
    this.emailid="";
    this.mobileNo="";
   
    this.showSearchCore=false;   
    this.selectCoreList=[];
  }
  
  getCorePanel(value: MatRadioChange) {
    this.showEmail=false;
    this.showMobile=false;
    this.SendEmailList=[];
    this.SendMobileList=[];
    this.emailid="";
    this.mobileNo="";
   
    this.showSearchCore=true;    
    this.selectCoreList=[];
  }

  deleteTaskTemplates(item:any) {
    const message = `Are you sure you want to delete selected template?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {         
          var reqModel = {
            taskTemplateSentToID: item.taskTemplateSentToID,
            userID: this.currentUser.UID,
            officeID: Number(this.myOfficeID),
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: Number(this.databaseId)
          }
          this.loaderService.show();
          this.settingsService.hardRemoveTaskTemplateSent(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.showOptionForDelete = false;
                this.selectedRecordDelete = [];
                this.loaderService.hide();
                this.toastr.success('Task templates deleted successfully.', '', {
                  timeOut: 3000,
                });
                this.showTemplateDetail(item.taskTemplateID);
              } else {
                this.showOptionForDelete = false;
                this.selectedRecordDelete = [];
                this.loaderService.hide();
                this.toastr.error('Task deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.showOptionForDelete = false;
              this.selectedRecordDelete = [];
              this.loaderService.hide();
              this.toastr.error('Task deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  AttachChecked:boolean=false;
  AssigneeChecked:boolean=true;
  NotifyChecked:boolean=false;
  SendEmailLater:boolean=false;
  
  showOptions(event:MatCheckboxChange,data): void {
    if(data=="Attach"){
     this.AttachChecked=event.checked;
    }
    if(data=="Assignee"){
      this.AssigneeChecked=event.checked;
    }
    if(data=="Notify"){
      this.NotifyChecked=event.checked;
    }
    if(data=="SendEmailLater"){
      this.SendEmailLater=event.checked;
    }
  }

  categoryTypeForTaskTemplates:number=0;

  OnChnageCategory($event) {
    if($event.value == "My Template"){
      this.categoryTypeForTaskTemplates=0;
    }
    if($event.value == "Organization"){
      this.categoryTypeForTaskTemplates=2;     
    }   
    this.getTaskTemplateList();   
  }

  objectList:any=[]=[];
  timeout = null;  
  selectCoreList: any = [];
  showSearchCore:boolean=false;
  attachedToCoreList:any=[]=[];
  CorefolderID: number = 0;
  roleIdList: any = [];
  searchName:string='';
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  stateCtrlValue:string;
  states= this.objectList;
  isShare: false;
  showAddCore: boolean = false;
  mainModuleName:string='';
  Module:string="";
  folderID:number=0;
  selectedCoreId:number=0;
  sendFrom:string="SendTasklist";
  TaskListName:string="";
  @ViewChild('SendTaskListURL',{static:true}) SendTaskListURLTemplate:TemplateRef<any>;
  taskTemplateAfterAddingCore:any;
  checkedByDefaultEmail=true;
  checkedByDefaultCore=true;

  searchCore(val) {
    this.attachedToCoreList=[];
    if (val.length >= 2) {
      this.attachedToCoreList = [];
      if (val != '') {
        this.searchName =val;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCore(val)
        }, 500);
      } else {
       this.attachedToCoreList = [];
      }
    }
  }    

  getsearchCore(searchValue: any) {   
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });
  
    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.formService.searchCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCoreList = response.data;
          this.attachedToCoreList.push({
            coreID: 0,
            name: 'Create New',
            email: '',
            imageUrl: '',
            shortName: '',
          });       
          } else {
          this.attachedToCoreList = [];
        }
      }
    })
  }

  ///***************************** */

  searchContacts(val) {
    if (val.length >= 2) {
      this.attachedToContactList = [];
      if (val != '') {
        this.searchName =val;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchContact(val)
        }, 500);
      } else {
        this.attachedToContactList = [];
      }
    }
  }
  getsearchContact(searchValue: any) {   
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if (SelectedCCC.length > 0) {
      this.ContactfolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });
    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.ContactfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchContact(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToContactList = response.data;
          this.attachedToContactList.push({
            contactID: 0,
            name: 'Create New',
            email: '',
            imageUrl: '',
            shortName: '',
          });       
        } else {
          this.attachedToContactList = [];
        }
      }
    })
  }
  OnChnageRelation($event,email) {  
    this.selectCoreList.find(m=>m.coreID==email.coreID).contactAttachWithCores[0].TransctionalRoleID= $event.value; 
  }
  //====== For Add Contact  ================//
  contactSelectedNew(contactSelected: any,emailid) {

    var check=[];
    this.contactsSelectedList=[];
    if(this.selectCoreList.find(m=>m.emailid==emailid).contactAttachWithCores.length>0)
    {
    check= this.selectCoreList.find(m=>m.emailid==emailid).contactAttachWithCores.filter(x=>x.contactID == contactSelected.contactID);
    if(check.length>0){
        this.stateCtrl.setValue('');  
        this.toastr.warning('Selected '+this.ContactShowName+' is allready added.', '', {
        timeOut: 3000,
      });
     return;
    }
  }
    if (contactSelected.contactID == 0) {
      this.stateCtrl.reset();
      this.dialog.closeAll();
      this.addNew('Contact',emailid);
      return;
    }     
    this.stateCtrl.setValue('');
    var shortName = "";
    shortName = contactSelected.name.match(/\b(\w)/g).join('');
     
    var obj={
      name: contactSelected.name,
      email: contactSelected.email,
      contactID: contactSelected.contactID,
      img: contactSelected.imageUrl,
      shortName:shortName,
      TransctionalRoleID:0
    }
    this.contactsSelectedList.push(obj);   
    this.selectCoreList.find(m=>m.emailid==emailid).contactAttachWithCores=this.contactsSelectedList;
  } 

  ////******************* */

  onNotASignerChange(event: Event, email: any) {
    let isTasklistCheckboxChecked = (event.target as HTMLInputElement).checked;
    this.selectCoreList.find(m=>m.emailid==email.emailid).isNotASigner=isTasklistCheckboxChecked;
    // if(isTasklistCheckboxChecked==true)
    // {
      // document.getElementById('1_Search' + email.emailid).style.display="block";
    // }
    // else
    // {
      // document.getElementById('1_Search' + email.emailid).style.display="none";
    // }
  }
  
  coreSelected(coreSelected: any) {     
    var check=[];
    check=this.selectCoreList.filter(x=>x.coreID == coreSelected.coreID);
    if(check.length>0){
        this.stateCtrl.setValue('');  
        this.toastr.warning('Selected '+this.CoreShowName+' is allready added.', '', {
        timeOut: 3000,
      });
     return;
    }

    if (coreSelected.coreID == 0) {
      this.stateCtrl.reset();
      this.dialog.closeAll();
      this.addNew('Core');
      return;
    } 
    this.selectedCoreEmailID=coreSelected.email;    
    this.selectCoreList.push({
      name: coreSelected.name,
      emailid: coreSelected.email,
      img: coreSelected.imageUrl,
      coreID: coreSelected.coreID,      
      shortName: coreSelected.shortName,
      isNotASigner:false,
      contactAttachWithCores:[]
    });
    this.stateCtrl.setValue('');  
    if (this.selectCoreList.length > 0) {
    }
    else {
    }
  }  

  addNew(module,emailid='') {
    this.mainModuleName = module;
    var menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    var Module = menuModulesList.filter((x) => x.mainModuleName == module);
    var Modulename = Module[0].orgModuleName;
    this.Module = Modulename;
    this.showAddCore = !this.showAddCore;
    this.selectedCoreEmailID=emailid;
  }

  getClose(message) {
    this.showAddCore = message;
  }
  GetRelationByTaskTemplateID(TaskTemplateID: any) {
    var ReqModel = {
      TaskTemplateID: Number(TaskTemplateID),
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
    }
    this.settingsService.GetRelationByTaskTemplateID(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess && response.data != null) {
         this.relationList=response.data;
        }else{
          this.relationList=[];
        }
      }else{
        this.relationList=[];
      }
    });
  }
  getselectedTransactionId(result) {
    if (result.FromModuleName == 'Core') {      
      var shortName = '';
      shortName = result.name.match(/\b(\w)/g).join('');
      this.selectedCoreEmailID=result.email;
      this.selectCoreList.push({
        name: result.name,
        emailid: result.email,
        img: "",
        coreID: result.transactionId,      
        shortName: shortName,
        isNotASigner:false,
        contactAttachWithCores:[]
      });
      if(this.selectCoreList.length > 0) {
      }
      else {
      }
      this.OpenFolderSendEmailAddingCore(this.SendTaskListURLTemplate,this.taskTemplateAfterAddingCore);
    }  
   else if (result.FromModuleName == 'Contact') {
    this.contactsSelectedList=[];      
      var shortName = '';
      shortName = result.name.match(/\b(\w)/g).join('');
      this.contactsSelectedList.push({
        name: result.name,
        email: result.email,
        img: "",
        contactID: result.transactionId,      
        shortName: shortName,
        TransctionalRoleID:0
      });
      if(this.selectCoreList.find(m=>m.emailid==this.selectedCoreEmailID))
      {
       this.selectCoreList.find(m=>m.emailid==this.selectedCoreEmailID).contactAttachWithCores=this.contactsSelectedList;
      }
      this.OpenFolderSendEmailAddingCore(this.SendTaskListURLTemplate,this.taskTemplateAfterAddingCore);
    }  
    if(result=="Close"){
      this.OpenFolderSendEmailAddingCore(this.SendTaskListURLTemplate,this.taskTemplateAfterAddingCore);
    }   
  }
  removeContactWithCoreCore(core)
  {
    this.selectedCoreEmailID=core.emailid;
    this.selectCoreList.find(m=>m.emailid==core.emailid).contactAttachWithCores=[];
    this.contactsSelectedList=[];
  }
  getUpdatedRecord(result){    
    if (result.FromModuleName == 'Core') {  
      if(this.selectCoreList.length>0){
        this.selectCoreList.find((item) => item.coreID == result.transactionId).name = result.name;
        this.selectCoreList.find((item) => item.coreID == result.transactionId).emailid = result.email;
        this.OpenFolderSendEmailAddingCore(this.SendTaskListURLTemplate,this.taskTemplateAfterAddingCore);
      }    
    }
  }

  OpenFolderSendEmailAddingCore(templateRef: TemplateRef<any>, taskTemplate: any) {
    this.TaskListName=taskTemplate.taskTemplateName;
    this.name="";
    this.emailid = "";
    this.addButtonShow = false;
    this.SendEmailList = [];
    
    this.AttachChecked=false;
    this.AssigneeChecked=true;
    this.NotifyChecked=false;

    this.searchName="";
    this.checkedByDefaultEmail=false;
    this.checkedByDefaultCore=true;
    this.showSearchCore=true;
    this.attachedToCoreList = [];

    this.taskTemplateID = taskTemplate.taskTemplateID;
    if (taskTemplate.taskListFolderID > 0) {
      this.taskListFolderID = taskTemplate.taskListFolderID;
    } else {
      this.taskListFolderID = 0;
    }

    this.showTemplateDetailCheckingDuplicateEmail(taskTemplate.taskTemplateID);
    this.ButtonForFolder = false;
    this.ButtonForUploadImage = false;

    this.showEmail=false;
    this.showMobile=false;
    this.SendEmailList=[];
    this.SendMobileList=[];
    this.emailid="";
    this.mobileNo="";
    this.sendButton=false;    
    this.stateCtrl.setValue('');  
    this.dialog.open(templateRef);
  }

   selectStagePopUp(task: any) {
      const dialogRef = this.dialog.open(AddUpdateProcessStageComponent, {
        data: {
          taskTemplateID:task.taskTemplateID,
          AddFrom:"Manage Task List Templates"         
        }     
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result!=null && result!=undefined){
          this.getTaskTemplateList();      
        }  
      });     
    }
    
  // selectStagePopUp(templateRef: TemplateRef<any>, task: any) {   
  //   this.buttonForStageProcess=false;
  //   this.taskTemplateID = task.taskTemplateID;
  //   this.processStageID = 0;
  //   this.getDashboardProcessStages();
  //   this.dialog.open(templateRef);    
  // }

  stageProcessList:any=[]=[];
  processStageID:number=0;
  buttonForStageProcess:boolean=false;

  getDashboardProcessStages() {
    var ReqModel = {
       userID: this.currentUser.UID,
       organizationID: Number(this.organizationId),
       databaseID: Number(this.databaseId),
       officeID:this.myOfficeID,
     }
    this.settingsService.getDashboardProcessStages(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess && response.data != null) {
          this.stageProcessList=response.data;
        }else{
          this.stageProcessList=[];
        }
      }else{
        this.stageProcessList=[];
      }
    });
  }


  selectStageFolder(data) {   
    this.processStageID = data.processStageID;
    this.buttonForStageProcess = true;
  }

   closeStageFolder() {
    this.spinner = false;
    this.buttonForStageProcess=false;
    this.processStageID = 0;
    this.dialog.closeAll();
  }

   setProcessStageforTaskTemplate() {    
    var ReqModel = {     
      tasktemplateID: this.taskTemplateID,
      processStageID: this.processStageID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.buttonForStageProcess = false;
    this.spinner = true;
    this.settingsService.setProcessStageforTaskTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Selected stage folder added in task template.', '', {
            timeOut: 3000,
          });
          this.getTaskTemplateList();
          this.closeStageFolder();
          this.loaderService.hide();         
        } else {         
          this.loaderService.hide();
        }
      } else {       
        this.loaderService.hide();
      }
    });
  }

   deleteprocessStage(data: any) {
    var message = `Are you sure you want to remove?`;  
    const title = `Confirm Remove`;
    const confirm = `Remove`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });  
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();       
        var ReqModel ={
          tasktemplateID: data.taskTemplateID,
          processStageID: 0,
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
          officeID: this.myOfficeID,
          officeIDList: this.OfficeIDList
        }        
        this.settingsService.setProcessStageforTaskTemplate(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.toastr.success('Stage remove successfully.', '', {
                timeOut: 3000,
              });
              this.getTaskTemplateList();
             // this.closeStageFolder();
              this.loaderService.hide();
            }
          }
        });
      }
    });
 }  

}